const answer = `The largest known star in the Milky Way is generally considered to be Stephenson 2-18, a red supergiant located in the direction of the constellation Scutum.

Here are some of its estimated properties:

* **Radius:** About **2,150 times the radius of the Sun** (estimates vary, roughly 2,000–2,300 solar radii).
* **Diameter:** Around **3 billion kilometers (1.9 billion miles)**.
* **Distance from Earth:** Approximately **19,000 light-years**.
* **Type:** Red supergiant.

To put its size in perspective:

* If Stephenson 2-18 replaced the Sun at the center of our Solar System, its surface would extend past the orbit of Saturn and possibly approach the orbit of Uranus, depending on the exact radius estimate.

### How certain is this?

It's not completely settled. Measuring the sizes of enormous stars is difficult because:

* Their outer atmospheres are diffuse rather than having a sharp edge.
* Dust and gas can obscure observations.
* Distance estimates affect radius calculations.

Other contenders for the largest known stars include:

* UY Scuti
* WOH G64 (though this star is in the Large Magellanic Cloud, not the Milky Way)
* VY Canis Majoris

Among stars that are currently believed to be in our galaxy, **Stephenson 2-18** is the leading candidate for the largest known by radius. Despite its immense size, it is not the most massive star—the most massive stars are typically much hotter and more compact than these giant red supergiants.`;

const response = {
  query: "largest star in the milky way",
  url: "https://chatgpt.com/",
  model: "gpt-5-5",
  answer,
  sources: [],
  related_queries: []
};

export const async_chatgpt = {
  input: "largest star in the milky way",
  result: JSON.stringify(response, null, 2)
};
